import * as React from "react";
import { forwardRef } from "react";
import { chakra, useStyleConfig } from "@chakra-ui/react";
export const ChevronDoubleLeftIcon = forwardRef(({ baseline = false, ...props }, ref) => {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return React.createElement(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: ref, ...props },
        React.createElement("path", { fillRule: "evenodd", d: "M11.983 8.07a1 1 0 0 1-.053 1.413L9.22 12l2.71 2.517a1 1 0 0 1-1.36 1.466l-3.5-3.25a1 1 0 0 1 0-1.466l3.5-3.25a1 1 0 0 1 1.413.053Z", clipRule: "evenodd" }),
        React.createElement("path", { fillRule: "evenodd", d: "M16.983 8.07a1 1 0 0 1-.053 1.413L14.22 12l2.71 2.517a1 1 0 0 1-1.36 1.466l-3.5-3.25a1 1 0 0 1 0-1.466l3.5-3.25a1 1 0 0 1 1.413.053Z", clipRule: "evenodd" }));
});
ChevronDoubleLeftIcon.displayName = "ChevronDoubleLeftIcon";
